import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import {
  Grid2 as Grid,
  Rating,
  Typography,
  Link,
  Paper,
  LinearProgress,
} from "@mui/material";
import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";
import { Charity, Testimonial } from "../../../shared/types";

export interface ImpactStatementsProps {
  charity: Charity;
}

export const ImpactStatements = ({
  charity,
}: ImpactStatementsProps): React.JSX.Element | null => {
  if (
    charity?.managed?.impactStatements &&
    charity.managed.impactStatements.length > 0
  ) {
    return (
      <Grid size={{ xs: 12 }} container>
        <Grid size={{ xs: 12 }}>
          <Typography
            variant="h4"
            style={{ textAlign: "center", paddingTop: "3px", width: "100%" }}
          >
            Incredible Things a Donation Can Do
          </Typography>
          <Grid size={{ xs: 12 }} container spacing={2}>
            {charity.managed.impactStatements
              .sort((a, b) => {
                return a.amount > b.amount ? 1 : 0;
              })
              .map((impactStatement, index) => {
                if (impactStatement.impact) {
                  return (
                    <React.Fragment key={index}>
                      <Grid size={{ xs: 1 }}>
                        <ArrowForwardIcon />
                      </Grid>
                      <Grid size={{ xs: 11 }}>
                        <Typography variant="body1">
                          ${impactStatement.amount} - {impactStatement.impact}
                        </Typography>
                      </Grid>
                    </React.Fragment>
                  );
                }
              })}
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return null;
  }
};
